import {
  CalculatorAutosDTO,
  FinancingCallDTO,
  CalculatorResponseDTO,
  RequestBalanceDTO,
} from './../../model/requests-model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequestFinanceService {
  constructor(private _http: HttpClient) {}

  financingSimulation(financeDto: FinancingCallDTO | CalculatorAutosDTO): Observable<CalculatorResponseDTO> {
    return this._http.post<CalculatorResponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlSimulationFinancing,
      financeDto
    );
  }

  requestBalanceIC(balanceIC: RequestBalanceDTO): Observable<RequestBalanceDTO> {
    return this._http.post<RequestBalanceDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlRequestBalanceIC,
      balanceIC
    );
  }
}
